// BuyButton.js
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { purchaseWithCredit, getDownload } from '../../utils/upload';
import { update_credits } from '../../utils/apputils';
import PaypalButton from './PaypalButton';
import { pricing, VATrate } from '../../utils/price_config';
import {
  buy as actions,
  paypal,
  users,
  receipts,
  modal
} from '../../store/actions';
import ModalView from './ModalView';
import Spinner from '../Spinner/Spinner.js';
import { buyNow, downloadSuccess, purchaseCredits } from '../../utils/google';

class BuyButton_Class extends Component {
  state = {
    show: false,
    paypal: true
  };

  imagePrice = (pricing.image.price * VATrate + pricing.image.price).toFixed(2);

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(actions.ready());
  }

  componentDidUpdate = ({ status: prevStatus }) => {
    const { status, user, template_key } = this.props;
    if (prevStatus === 'BUY.MAINURLRECEIVED' && status === 'BUY.COMPLETE') {
      downloadSuccess(template_key, user);
    }
  };

  handleClick = buttonInnerText => {
    const { template_key } = this.props;
    this.handleShow();
    if (buttonInnerText === 'Buy now') buyNow(template_key);
  };

  handleClose = () => {
    const { dispatch } = this.props;
    dispatch(receipts.ready());
    this.setState({
      show: false,
      paypal: false
    });
  };

  handleShow = () => {
    const { dispatch } = this.props;
    dispatch(paypal.ready());
    this.setState({
      show: true,
      paypal: true
    });
  };

  clickBuyButton = e => {
    e.preventDefault();
    const { dispatch, template_key, upload_key } = this.props;
    dispatch(actions.buying());
    const getter = async () => {
      const takeCredit = await purchaseWithCredit(template_key, upload_key);
      if (takeCredit !== 'Successfully taken 1 credit') {
        return;
      }
      update_credits(dispatch);
      this.onPayment();
    };
    getter();
  };

  onPayment = receipt => {
    const { dispatch, template_key, upload_key } = this.props;
    dispatch(actions.buying());
    const getter = async () => {
      const result = await getDownload(template_key, upload_key);
      window.location.href = result['download_url'];
      dispatch(actions.mainurlreceived(result['download_url']));
      dispatch(actions.complete());
    };
    getter();
    if (receipt) {
      dispatch(receipts.setCurrentReceipt(receipt.response));
    }
  };

  clickDownload = () => {
    const { download_url } = this.props;
    window.location.href = download_url;
  };

  handleShowBuyCredits = () => {
    const { dispatch } = this.props;
    dispatch(modal.showModal());
  };

  setReceipt = () => {
    const { receipt } = this.props;
    localStorage.setItem('receipts', JSON.stringify(receipt));
  };

  handleBuyCredits = () => {
    this.handleShowBuyCredits();
    purchaseCredits();
  };

  renderButton = () => {
    const { status, credits } = this.props;
    switch (status) {
      case actions.types.BUYING:
        return (
          <button type="button" className="btn btn-success btn-bevel" disabled>
            <small>Your download has started</small>
            <Spinner type="regular" />
          </button>
        );
      case actions.types.COMPLETE:
        return (
          <button
            onClick={this.clickDownload}
            type="button"
            className="btn btn-success btn-bevel"
          >
            <strong>Download again</strong> <br />
            <span className="glyphicon glyphicon-download-alt" />
            <br />
            <small>Click here if download does not start</small>
          </button>
        );
      default:
        return credits > 0 ? (
          <button
            onClick={this.clickBuyButton}
            type="button"
            className="btn btn-primary btn-bevel"
          >
            <strong>Download now</strong> <br />
            <span className="glyphicon glyphicon-download-alt" />
            <br />
            <small>Download pic for 1 credit</small>
          </button>
        ) : (
          <button
            onClick={this.handleBuyCredits}
            type="button"
            className="btn btn-primary btn-bevel"
          >
            <strong>Buy credits</strong>
          </button>
        );
    }
  };

  handleCloseSignup = () => {
    const { dispatch } = this.props;
    dispatch(users.logout());
  };

  handleShowSignup = () => {
    const { dispatch } = this.props;
    dispatch(users.show_register());
  };

  handleShowLogin = () => {
    const { dispatch } = this.props;
    dispatch(users.show_login());
  };

  renderPaymentModal = () => {
    const {
      status,
      paypalStatus,
      user,
      receipt,
      template_width,
      template_height,
      thumbnail,
      dispatch,
      buttonClickMsg
    } = this.props;
    const close = this.handleClose;
    const show = this.state.show;
    let footerTip;
    let id;
    let title;
    let body;
    let footer;
    if (status === 'BUY.READY' && !user) {
      id = 'm_buyLabel';
      title = 'Take your pic';
      footerTip = true;
      footer = (
        <div>
          <div className="tip-text">
            <span>
              Each credit buys you one image mockup, which is saved in your
              account forever.
            </span>
          </div>
        </div>
      );
      body = (
        <div className="columns">
          <div className="col">
            <h3 className="bar-header bar-header--secondary">Buy now</h3>
            <div className="tint-box tint-box-buy">
              <p>
                No account required, just pay and download.
                <strong>
                  <span className="price price-lg">
                    <span className="curr">&pound;</span>
                    <span className="num">{this.imagePrice}</span>
                  </span>
                </strong>
                {template_width} &times; {template_height}
              </p>
              {buttonClickMsg ? (
                <p className="smallprint buy-now-warning">{buttonClickMsg}</p>
              ) : null}
              {this.state.paypal && (
                <PaypalButton
                  dispatch={dispatch}
                  creditsPackage={pricing.image}
                  onPayment={this.onPayment}
                  status={paypalStatus}
                />
              )}
            </div>
          </div>
          <div className="col">
            <h3 className="bar-header bar-header--primary">
              Save with an account
            </h3>
            <Table className="price-table">
              <tbody>
                {pricing.credits.map((credit, i) => {
                  const totalPrice = credit.price * VATrate + credit.price;
                  return (
                    <tr key={`table${i}`}>
                      <th>{credit.name} credits</th>
                      <td className="discount">{`Save £${(
                        this.imagePrice * credit.name -
                        totalPrice
                      ).toFixed(2)}`}</td>
                      <td>
                        <span className="price">
                          <span className="curr">&pound;</span>
                          <span className="num">{`${totalPrice.toFixed(
                            2
                          )}`}</span>
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <button
              type="button"
              className="btn btn-bevel btn-block btn-lg"
              onClick={this.handleShowLogin}
            >
              Log in
            </button>
            <button
              type="button"
              className="btn btn-primary btn-bevel btn-block btn-lg"
              onClick={this.handleShowSignup}
            >
              Sign up
            </button>
          </div>
        </div>
      );
    } else {
      id = 'm_confirmLabel';
      title = user ? 'The Count approves. Do you?' : 'Purchase complete';
      body = (
        <div>
          <div className="confirm-img">
            <img src={thumbnail} width="310" alt="" />
          </div>
          <div className="modal-footer">
            <div className="footer-buttons">
              {!user && Object.keys(receipt).length ? (
                <Link to="/receipts/anon" target="_blank">
                  <button
                    type="button"
                    className="btn btn-primary btn-bevel"
                    onMouseDown={this.setReceipt}
                  >
                    View receipt
                  </button>
                </Link>
              ) : (
                <button
                  type="button"
                  className="btn btn-default btn-bevel"
                  onClick={this.handleClose}
                >
                  Cancel
                </button>
              )}
              {this.renderButton()}
            </div>
          </div>
        </div>
      );
      footerTip = true;
      footer = (
        <div>
          {!user ? (
            <div className="tip-text">
              {Object.keys(receipt).length ? (
                <div>
                  <span>Please print or save your receipt before closing.</span>
                  <br />
                </div>
              ) : null}
              <span>
                Want to save your pics and receipts to view later? Sign up for
                an account, where you can also access other download sizes, for
                no extra cost.
              </span>
            </div>
          ) : (
            <div className="tip-text">
              <span>
                Your pic will be saved in your account, where you can also
                access other download sizes, for no extra cost.
              </span>
            </div>
          )}
        </div>
      );
    }
    return (
      <ModalView
        id={id}
        title={title}
        body={body}
        footer={footer}
        footerTip={footerTip}
        show={show}
        close={close}
      />
    );
  };

  render() {
    const { uploadComplete, status } = this.props;
    const txt =
      status === actions.types.COMPLETE ? 'Download again' : 'Buy now';
    return (
      <Fragment>
        <button
          className="btn btn-primary btn-bevel btn-block"
          onClick={() => this.handleClick(txt)}
          disabled={!uploadComplete}
        >
          <strong>{txt}</strong>
          <br />
        </button>
        {this.renderPaymentModal()}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  credits: state.users.credits,
  user: state.users.user,
  thumbnail: state.uploads.preview_url,
  width: state.uploads.template_width,
  height: state.uploads.template_height,
  template_key: state.uploads.template_key,
  upload_key: state.uploads.upload_key,
  status: state.buy.status,
  paypalStatus: state.paypal.status,
  download_url: state.buy.main_url,
  receipt: state.receipts.receipt,
  template_width: state.uploads.template_width,
  template_height: state.uploads.template_height,
  buttonClickMsg: state.paypal.buttonClickMsg
});
export const BuyButton = connect(mapStateToProps)(BuyButton_Class);



// WEBPACK FOOTER //
// ./src/comps/Feature/BuyButton.js